if(document.querySelector('.faqs')){
    document.querySelectorAll('.card-header').forEach((headerButton) => {
        headerButton.addEventListener('click', (event) => {
            const btn = event.currentTarget
            const content = btn.nextElementSibling
    
            btn.classList.toggle('collapsed');
    
            if (content.style.maxHeight){
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}